import styles from "./DownloadInvoiceButton.module.scss"
import Icon from "../Icon"
import { t } from "i18next"
import { downloadReceipt } from "../../model/helpers/Session";

type Props = {
	ticketGUID: string;
}

const DownloadInvoiceButton: React.FC<Props> = ({
	ticketGUID
}) => {
	const handleDownloadReceipt = () => {
		downloadReceipt(ticketGUID);
	};
	
	return (
		<button
			type="submit"
			className={`${styles.actionBtn} ${styles.defaultBtn} ${styles.text500}`}
			onClick={() => handleDownloadReceipt()}
		>
			<Icon.Document color={"black"} size={16} />
			&nbsp;{t("paid.invoice")}
		</button>
	)
}

export default DownloadInvoiceButton;